import Routes from "./Routes";
import { ToastContainer } from 'react-toastify';
import 'react-loading-skeleton/dist/skeleton.css'
import { SkeletonTheme } from "react-loading-skeleton";
import UploadProgressWidget from "./components/UploadProgressWidget";
import useApp from "./hooks/useApp";
import { IframeSecurityGuard } from "./hooks/useIframeSecurity";
import { ProductProvider } from "./contexts/ProductContext";
import { ConfirmProvider } from "./contexts/ConfirmContext";

// Enable iframe security validation (can be disabled via environment variable)
const ENABLE_IFRAME_SECURITY = import.meta.env.VITE_ENABLE_IFRAME_SECURITY !== 'false';

function App({ components }) {
  useApp();

  return (
    <ProductProvider components={components}>
      <IframeSecurityGuard enforce={ENABLE_IFRAME_SECURITY}>
        <SkeletonTheme>
          <ConfirmProvider>
            <div>
              <Routes />
              <ToastContainer />
              <UploadProgressWidget />
            </div>
          </ConfirmProvider>
        </SkeletonTheme>
      </IframeSecurityGuard>
    </ProductProvider>
  );
}

export default App;
